import styled from 'styled-components'

const DivDetailsPlaylist = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .nome-playlist {
    font-size: 20px;
    margin-bottom: 4px;
  }
  .info {
    margin-top: 8px;
  }
`

export { DivDetailsPlaylist }
